import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import SmartQuotes from 'components/SmartQuotes'

const styles = (theme) => ({
  root: {
    margin: '10px auto',
    padding: '25px 15px',
    background: '#f4f8fb',
    border: '1px solid #d1bade',
    // border: `1px solid ${theme.palette.borders.cloudiest}`,
    color: theme.palette.quote,
    fontWeight: 500,
  },
  header: {
    textTransform: 'uppercase',
    color: '#a974ba',
    fontWeight: 500,
    fontSize: '0.75em',
    marginBottom: 2,
  },
  quote: {
    fontWeight: 700,
    color: '#6c9bab',
    fontStyle: 'italic',
    textTransform: 'none',
    fontSize: '1.4em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1em',
      fontWeight: 700,
    },
  },
})

const Quote = (props) => {
  const { classes, author, quote, tags } = props

  return (
    <div className={classes.root}>
      <Typography align="center" className={classes.header}>
        Inspiration of the article:
      </Typography>
      <Typography align="center" variant="title" className={classes.quote}>
        <SmartQuotes quote={quote} /> {author && '\u2014' + author}
      </Typography>
    </div>
  )
}

Quote.propTypes = {
  classes: PropTypes.object.isRequired,
  author: PropTypes.string,
  quote: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
}

export default withStyles(styles)(Quote)



// WEBPACK FOOTER //
// ./src/components/Articlepage/Quote.js